/* THE ARK — collection/search filtering (Section Rendering API, no framework) */
(function(){
  "use strict";
  var root=document.querySelector("[data-facets]"); if(!root) return;
  var section=root.dataset.section, busy=null, deb=null;
  function $(s,c){return (c||document).querySelector(s);}
  function drawer(){return $("[data-facets-drawer]");}
  var scrim=document.createElement("div"); scrim.className="scrim facets-scrim"; document.body.appendChild(scrim);

  function open(){ var d=drawer(); d.classList.add("on"); d.setAttribute("aria-hidden","false"); scrim.classList.add("on");
    document.body.style.overflow="hidden"; var b=$("[data-facets-open]"); if(b) b.setAttribute("aria-expanded","true");
    var f=d.querySelector("summary"); if(f) f.focus({preventScroll:true}); }
  function close(){ var d=drawer(); d.classList.remove("on"); d.setAttribute("aria-hidden","true"); scrim.classList.remove("on");
    document.body.style.overflow=""; var b=$("[data-facets-open]"); if(b){ b.setAttribute("aria-expanded","false"); } }

  function paramsFromForm(){
    var fd=new FormData($("[data-facets-form]")), p=new URLSearchParams();
    fd.forEach(function(v,k){ if(v!=="") p.append(k,v); });
    return p;
  }
  function load(url, push){
    var u=new URL(url, location.origin);
    var fetchUrl=new URL(u); fetchUrl.searchParams.set("section_id", section);
    if(busy) busy.abort(); busy=("AbortController" in window)?new AbortController():null;
    document.body.classList.add("facets-loading");
    fetch(fetchUrl, busy?{signal:busy.signal}:{}).then(function(r){return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,"text/html");
      // keep which filter groups are expanded
      var openKeys={}; document.querySelectorAll(".fd-group").forEach(function(g){ openKeys[g.dataset.key]=g.open; });
      [["[data-facets-results]"],["[data-facets-active]"],[".fd-body"],[".fd-foot"],[".facets-open"]].forEach(function(s){
        var a=$(s[0]), b=doc.querySelector(s[0]); if(a&&b) a.replaceWith(b);
      });
      document.querySelectorAll(".fd-group").forEach(function(g){ if(g.dataset.key in openKeys) g.open=openKeys[g.dataset.key]; });
      if(push!==false) history.replaceState({}, "", u.pathname+u.search);
      document.dispatchEvent(new CustomEvent("ark:content",{detail:{root:$("[data-facets-results]")}}));
    }).catch(function(e){ if(e&&e.name==="AbortError") return; location.href=u; })
      .finally(function(){ document.body.classList.remove("facets-loading"); });
  }
  function submit(){ var p=paramsFromForm(); load(location.pathname+(p.toString()?"?"+p:"")); }

  document.addEventListener("click", function(e){
    if(e.target.closest("[data-facets-open]")){ e.preventDefault(); open(); return; }
    if(e.target.closest("[data-facets-close]")){ e.preventDefault(); close(); return; }
    var pre=e.target.closest(".fd-preset");
    if(pre){ e.preventDefault(); var g=pre.closest(".fd-group");
      var mn=g.querySelector("input[name$='gte']"), mx=g.querySelector("input[name$='lte']");
      if(mn) mn.value=""; if(mx) mx.value=pre.dataset.max; submit(); return; }
    var a=e.target.closest("a[data-facets-link]");
    if(a && !e.metaKey && !e.ctrlKey){ e.preventDefault(); load(a.href); if(a.closest(".pager")) root.scrollIntoView({behavior:"smooth"}); }
  });
  scrim.addEventListener("click", close);
  addEventListener("keydown", function(e){ if(e.key==="Escape" && drawer().classList.contains("on")) close(); });
  document.addEventListener("change", function(e){
    if(e.target.closest("[data-facets-form]")){
      clearTimeout(deb); deb=setTimeout(submit, e.target.type==="number"?600:80);
    }
    if(e.target.matches("[data-facets-sort]")){
      var h=$("[data-facets-sort-hidden]"); if(h) h.value=e.target.value; submit();
    }
  });
  document.addEventListener("submit", function(e){ if(e.target.closest("[data-facets-form]")){ e.preventDefault(); submit(); } });
})();
